import { ExportDataEntityEnum } from '../../../../shared/models';
import { PropertyTypeEnum } from '../../../../shared/properties';
import { generateViewColumnKeyFromMapping, ViewColumn } from '../../view';
import { caseViewColumnDefinition } from '../../view/case-view-column.definition';
import {
  ExportColumnDefinition,
  ExtractKeys,
} from './export-data-column.definition';

export const CASE_EXPORT_DATA_COLUMN_KEYS = [
  'case_id',
  'case_name',
  'case_status',
  'case_progress',
  'case_tags',
  'case_assignee',
  'case_template',
  'case_risk_level',
  'case_risk_score',
  'case_next_review_at',
  'case_last_activity_at',
  'case_contact_has_actions',
  'case_reviewer_has_actions',
  'case_external_id',
  'case_reviewed_at',
  'case_reviewed_by',
  'case_reviewer_type',
  'case_review_comment',
  'case_created_at',
  'case_updated_at',
] as const;

// Type-safe keys type
export type CaseExportDataColumnKey = ExtractKeys<
  typeof CASE_EXPORT_DATA_COLUMN_KEYS
>;

export const caseExportDataColumnDefinitionMap: Record<
  CaseExportDataColumnKey,
  ViewColumn<PropertyTypeEnum, PropertyTypeEnum>
> = {
  case_id: caseViewColumnDefinition.id,
  case_name: caseViewColumnDefinition.name,
  case_status: caseViewColumnDefinition.status,
  case_progress: caseViewColumnDefinition.progress,
  case_tags: caseViewColumnDefinition.tags,
  case_assignee: caseViewColumnDefinition.assignee,
  case_template: caseViewColumnDefinition.template,
  case_risk_level: caseViewColumnDefinition.currentRiskLevel,
  case_risk_score: caseViewColumnDefinition.currentRiskScore,
  case_next_review_at: caseViewColumnDefinition.nextReviewAt,
  case_last_activity_at: caseViewColumnDefinition.lastActivityAt,
  case_contact_has_actions: caseViewColumnDefinition.contactHasActions,
  case_reviewer_has_actions: caseViewColumnDefinition.reviewerHasActions,
  case_external_id: caseViewColumnDefinition.externalId,
  case_reviewed_at: caseViewColumnDefinition.reviewedAt,
  case_reviewed_by: caseViewColumnDefinition.reviewedBy,
  case_reviewer_type: caseViewColumnDefinition.reviewerType,
  case_review_comment: caseViewColumnDefinition.reviewComment,
  case_created_at: caseViewColumnDefinition.createdAt,
  case_updated_at: caseViewColumnDefinition.updatedAt,
};

export const caseViewColumnKeyToExportColumnKey: Record<
  string,
  CaseExportDataColumnKey
> = Object.entries(caseExportDataColumnDefinitionMap).reduce(
  (acc, [key, { mapping }]) => {
    acc[generateViewColumnKeyFromMapping(mapping)] =
      key as CaseExportDataColumnKey;
    return acc;
  },
  {} as Record<string, CaseExportDataColumnKey>,
);

export const caseExportDataColumnDefinition: ExportColumnDefinition<CaseExportDataColumnKey>[] =
  CASE_EXPORT_DATA_COLUMN_KEYS.map((caseColumnKey) => ({
    uniqueKey: caseColumnKey,
    sourceEntity: ExportDataEntityEnum.case,
    viewColumn: caseExportDataColumnDefinitionMap[caseColumnKey],
  }));
